// extracted by mini-css-extract-plugin
export default {"form":"EmailSent_form__C8xxH","page-beehero-logo":"EmailSent_page-beehero-logo__oV2Wp","title-email-sent":"EmailSent_title-email-sent__7qMnG"};